import PasswordField from 'components/form/password';
import validationSchema from 'validation/user/login';
import { Grid, TextField, Button, Divider } from 'components/ui';
import { Formik } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';
import { WideForm } from 'components/styles_components/form';
import { RegisterLink, ForgotPasswordLink } from 'utils/link';
import { StyledLink } from 'components/styles_components/link';
import { DividerContainer } from 'components/styles_components/container';

const LoginForm = ({ initialValues, onSubmit, processing }) => {
  const intl = useIntl();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema(intl)}
      onSubmit={onSubmit}
    >
      {({ handleSubmit, handleChange, handleBlur, values, touched, errors }) => (
        <WideForm onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin="dense"
            id="email"
            name="email"
            label={intl.formatMessage({ id: 'user.email' }) + ' *'}
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={(touched.email && Boolean(errors.email)) || undefined}
            helperText={touched.email && errors.email}
          />
          <PasswordField
            fullWidth
            margin="dense"
            id="password"
            name="password"
            label={intl.formatMessage({ id: 'user.password' }) + ' *'}
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            error={(touched.password && Boolean(errors.password)) || undefined}
            helperText={touched.password && errors.password}
          />
          <StyledLink to={ForgotPasswordLink()}>
            <FormattedMessage id="button.forgot_password" />
          </StyledLink>
          <Button
            sx={{ mt: 1 }}
            fullWidth
            disabled={processing}
            color="primary"
            variant="contained"
            type="submit"
          >
            <FormattedMessage id="button.login" />
          </Button>
          <DividerContainer />
          <Divider>
            <FormattedMessage id="auth.login.no_account" />
          </Divider>
          <DividerContainer />
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <StyledLink to={RegisterLink()}>
              <FormattedMessage id="button.register" />
            </StyledLink>
          </Grid>
        </WideForm>
      )}
    </Formik>
  );
};

export default LoginForm;
